import { render } from "./MyEvents.vue?vue&type=template&id=4bbd5ac0&ts=true"
import script from "./MyEvents.vue?vue&type=script&lang=ts"
export * from "./MyEvents.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__